import { Box, Tabs, Typography, Tab } from "@mui/material";
import PriorityHighRoundedIcon from "@mui/icons-material/PriorityHighRounded";
import React from "react";
import { useTranslation } from "react-i18next";

export default function StepList({
  questionToUpdate,
  handleChangeValue,
  listOfSteps,
  stepId,
  setIsStepCompleeted,
  stepComleted,
  question_id,
}) {
  const language = localStorage.getItem("i18nextLng");
  const { t } = useTranslation();

  return (
    <>
      {/* Header */}
      <Box style={{ marginTop: "7vh", marginBottom: "20px" }}>
        <Typography
          variant="h5" // Increased font size for the header
          sx={{
            fontWeight: "bold",
            fontSize: "24px", // Larger font size
            color: "#333",
            padding: "15px 0", // Adjusted padding
          }}
        >
          {t("organization_profile_steps")}
        </Typography>
      </Box>

      {/* Tab Navigation */}
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={stepId}
        onChange={handleChangeValue}
        aria-label="Vertical tabs example"
        sx={{
          ".MuiTabs-flexContainer": {
            flexDirection: "column", // Ensure vertical layout
          },
          ".MuiTabs-indicator": {
            left: 0,
            backgroundColor: "#0FB694", // Indicator color
            width: "4px", // Thinner indicator
            borderRadius: "4px 0 0 4px", // Rounded indicator
            transition: "transform 0.3s ease-out", // Smooth transition
          },
          ".MuiButtonBase-root": {
            alignItems: "center",
            color: "#555", // Default text color
            textAlign: "left",
            marginBottom: "12px", // Increased spacing between tabs
            padding: "16px 20px", // Increased padding for better touch area
            "&:hover": {
              color: "#0FB694", // Hover text color
            },
          },
          ".Mui-selected": {
            color: "#0FB694 !important", // Selected text color
            fontWeight: "bold", // Emphasize selected tab
          },
        }}
      >
        {/* Generate Tabs */}
        {listOfSteps.map((step) => (
          <Tab
            key={step.identifier}
            value={step.identifier}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px", // Space between text and icon
                }}
              >
                <Typography
                  variant="subtitle1" // Larger font size for tab labels
                  sx={{
                    fontSize: "16px", // Increased font size
                    fontWeight: "500",
                    color: step.is_completed ? "#00a07f" : "inherit",
                    fontWeight: step.is_completed ? "bold" : "normal",
                  }}
                >
                  {` ${language === "fr" ? step.value_fr : step.value}`}
                </Typography>
                {/* Conditionally render the icon here */}
                {!step.is_completed && <PriorityHighRoundedIcon />}
              </Box>
            }
            iconPosition="end" // Move the icon to the end
            sx={{
              textTransform: "none", // Disable uppercase transformation
              justifyContent: "flex-start",
              height: "auto", // Allow dynamic height
            }}
          />
        ))}
      </Tabs>
    </>
  );
}
